import React from "react";
import { authHeaders } from "../auth";
import "./ExportButton.css";

const API_BASE = process.env.REACT_APP_API_BASE;

function ExportButton({ columns, rows, displayColumns, summary, chartType, title }) {
  if (!columns || !rows || rows.length === 0) return null;

  const download = async (path, ext) => {
    try {
      const res = await fetch(`${API_BASE}/files/export/${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify({
          columns, display_columns: displayColumns, rows,
          summary: summary || null, chart_type: chartType || "bar",
          title: title || "Siragu Report",
        }),
      });
      if (!res.ok) throw new Error(`status ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `siragu_${Date.now()}.${ext}`;
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      /* silent — CSV fallback remains */
    }
  };
  const handleExportXlsx = () => download("xlsx", "xlsx");
  const handleExportPptx = () => download("pptx", "pptx");
  const handleExportPdf = () => download("pdf", "pdf");

  const handleExport = () => {
    const escape = (val) => {
      const str = val === null || val === undefined ? "" : String(val);
      if (str.includes(",") || str.includes('"') || str.includes("\n")) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const header = columns.map(escape).join(",");
    const body = rows.map((row) => columns.map((col) => escape(row[col])).join(",")).join("\n");
    const csv = header + "\n" + body;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `export_${Date.now()}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const DownloadIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
    </svg>
  );

  return (
    <div className="export-btn-group">
      <span className="export-btn-label">Export:</span>
      <button className="export-btn" onClick={handleExportXlsx}><DownloadIcon /> Excel</button>
      <button className="export-btn" onClick={handleExportPptx}><DownloadIcon /> PPT</button>
      <button className="export-btn" onClick={handleExportPdf}><DownloadIcon /> PDF</button>
      <button className="export-btn export-btn-secondary" onClick={handleExport}>CSV</button>
    </div>
  );
}

export default ExportButton;
